const colors = {

}

export default colors